import {
  GLOBAL_SET_LIST_PLACES,
  GLOBAL_SET_LIST_CURRENCIES,
  GLOBAL_SET_LIST_CATEGORIES,
  GLOBAL_SET_LIST_PROMOTIONS,
  GLOBAL_SET_LIST_ADDITIONALS,
  GLOBAL_SET_SPINNER,
  GLOBAL_SET_LIST_LANGUAGES,
  GLOBAL_SET_LIST_LANGUAGES_INFO,
  GLOBAL_SET_LIST_HOLIDAYS,
  GLOBAL_SET_LIST_SCHEDULES,
  GLOBAL_SET_LIST_COUNTRIES,
  GLOBAL_SET_LIST_CITIES,
  GLOBAL_SET_LIST_DOCUMENT_TYPES,
  GLOBAL_SET_LIST_FISCAL_CONDITIONS,
  GLOBAL_SET_GENERAL_SETTINGS,
  GLOBAL_SET_WEB_CURRENCY,
  CHANGE_CURRENCY,
} from '../utils/types';

const INITIAL_STATE = {
  listPlaces: null,
  listCategories: null,
  listPromotions: null,
  listAdditionals: null,
  listSchedules: null,
  listHolidays: null,
  listCurrencies: null,
  defaultCurrency: null,
  listLanguages: null,
  listLanguagesInfo: null,
  listCountries: null,
  listCities: null,
  listDocumentTypes: null,
  listFiscalConditions: null,
  currentLanguage: 'es',
  spinner: false,
  generalSettings: null,
  currentCurrency: null,
  webCurrency: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GLOBAL_SET_LIST_PLACES: {
      return {
        ...state,
        listPlaces: action.payload,
      };
    }
    case GLOBAL_SET_LIST_CURRENCIES: {
      const defaultCurrency = action.payload.find(currency => currency.isSystemDefault === true);
      return {
        ...state,
        listCurrencies: action.payload,
        defaultCurrency,
      };
    }

    case GLOBAL_SET_WEB_CURRENCY: {
      return {
        ...state,
        webCurrency: action.payload,
      };
    }

    case CHANGE_CURRENCY: {
      return {
        ...state,
        currentCurrency: action.payload,
      };
    }

    case GLOBAL_SET_LIST_CATEGORIES: {
      return {
        ...state,
        listCategories: action.payload,
      };
    }
    case GLOBAL_SET_LIST_PROMOTIONS: {
      return {
        ...state,
        listPromotions: action.payload,
      };
    }
    case GLOBAL_SET_LIST_ADDITIONALS: {
      return {
        ...state,
        listAdditionals: action.payload,
      };
    }
    case GLOBAL_SET_LIST_HOLIDAYS: {
      return {
        ...state,
        listHolidays: action.payload,
      };
    }
    case GLOBAL_SET_LIST_SCHEDULES: {
      return {
        ...state,
        listSchedules: action.payload,
      };
    }
    case GLOBAL_SET_LIST_LANGUAGES: {
      return {
        ...state,
        listLanguages: action.payload,
      };
    }
    case GLOBAL_SET_LIST_LANGUAGES_INFO: {
      return {
        ...state,
        listLanguagesInfo: action.payload,
      };
    }
    case GLOBAL_SET_LIST_COUNTRIES: {
      return {
        ...state,
        listCountries: action.payload,
      };
    }
    case GLOBAL_SET_LIST_CITIES: {
      return {
        ...state,
        listCities: action.payload,
      };
    }
    case GLOBAL_SET_SPINNER: {
      return {
        ...state,
        spinner: action.payload,
      };
    }
    case GLOBAL_SET_LIST_DOCUMENT_TYPES: {
      return {
        ...state,
        listDocumentTypes: action.payload,
      };
    }
    case GLOBAL_SET_LIST_FISCAL_CONDITIONS: {
      return {
        ...state,
        listFiscalConditions: action.payload,
      };
    }
    case GLOBAL_SET_GENERAL_SETTINGS: {
      return {
        ...state,
        generalSettings: action.payload,
      };
    }

    default:
      return state;
  }
};
